export enum ConfigTaskTypes {
  GET_CONFIG_TASK = '@@configTask/GET_CONFIG_TASK',
  GET_CONFIG_TASK_SUCCESS = '@@configTask/GET_CONFIG_TASK_SUCCESS',
  GET_CONFIG_TASK_FAIL = '@@configTask/GET_CONFIG_TASK_FAIL',

  GET_CONFIG_TASK_DETAIL = '@@configTask/GET_CONFIG_TASK_DETAIL',
  GET_CONFIG_TASK_DETAIL_SUCCESS = '@@configTask/GET_CONFIG_TASK_DETAIL_SUCCESS',
  GET_CONFIG_TASK_DETAIL_FAIL = '@@configTask/GET_CONFIG_TASK_DETAIL_FAIL',

  ADD_CONFIG_TASK = '@@configTask/ADD_CONFIG_TASK',
  ADD_CONFIG_TASK_SUCCESS = '@@configTask/ADD_CONFIG_TASK_SUCCESS',
  ADD_CONFIG_TASK_FAIL = '@@configTask/ADD_CONFIG_TASK_FAIL',

  DELETE_CONFIG_TASK = '@@configTask/DELETE_CONFIG_TASK',
  DELETE_CONFIG_TASK_SUCCESS = '@@configTask/DELETE_CONFIG_TASK_SUCCESS',
  DELETE_CONFIG_TASK_FAIL = '@@configTask/DELETE_CONFIG_TASK_FAIL',

  UPDATE_CONFIG_TASK = '@@configTask/UPDATE_CONFIG_TASK',
  UPDATE_CONFIG_TASK_SUCCESS = '@@configTask/UPDATE_CONFIG_TASK_SUCCESS',
  UPDATE_CONFIG_TASK_FAIL = '@@configTask/UPDATE_CONFIG_TASK_FAIL',
}
